export default function getCSRFToken() {
    const cookie = document.cookie.trim();

    if (cookie === '') return;

    const token = cookie
        .split(';')
        .map((c) => c.trim())
        .filter((c) => c.startsWith('csrftoken='));

    if (token.length === 0) return;

    const tokenValue = token[0].split('=')[1];

    if (tokenValue.length === 0) return;

    return decodeURIComponent(tokenValue);
}
